import React from "react";
import { withStyles } from "@material-ui/core";
import { compose } from "recompose";
import AddRoundedIcon from "@material-ui/icons/AddRounded";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import EditIcon from "@material-ui/icons/Edit";
import Tooltip from "./../../../../common/StyledToolTip";
import ToggleAnchorPoints from "./ToggleAnchorPoints";
import { withFeatureFlags } from "../../../../../userProfile/featureFlagsContext";
import appConstants from "../../../../../appConstants";

const styles = (theme) => ({
  headerStyle: {
    padding: "12px 0px",
    borderRadius: "4px 4px 0 0",
  },
  toggleIconLayout: {
    float: "right",
    display: "flex",
    color: theme.iconColor,
    "&>span": {
      color: theme.iconColor,
    },
    alignItems: "center",
    height: "19px",
  },
  headerLabel: {
    color: theme.HeaderSelectedText,
    fontSize: "14px",
    fontWeight: 600,
  },
  headerIconStyles: {
    padding: "5px 10px",
    borderLeft: `1px solid ${theme.AppBGColor}`,
    color: theme.iconColor,
  },
  disableIcon: {
    cursor: "not-allowed",
    opacity: 0.7,
  },
  enableIcon: {
    cursor: "pointer",
  },
  iconLayout: {
    float: "right",
    color: theme.iconColor,
    "&>span": {
      padding: "10px 10px",
      color: theme.iconColor,
    },
  },
});

const AnchorPointGridHeader = ({
  classes,
  isAddUpdateAnchorPointFormOpen,
  enableAllAnchorPoints,
  selectedAnchorPoints,
  addAnchorPointOpen,
  updateAnchorPointOpen,
  onAllAnchorPointToggleClicked,
  deleteAnchorPointPopupOpen,
  isEnableAnchorPointsInProgress,
  featureFlags,
}) => {
  const getIconTitle = (params) => {
    const {
      iconName,
      isAddUpdateAnchorPointFormOpen,
      enableAllAnchorPoints,
      disableEditDeleteIcon,
      disableAddIcon
    } = params;
    if (isAddUpdateAnchorPointFormOpen) {
      return "Add/update in progress";
    }
    switch (iconName) {
      case "toggleAllAnchorPoint":
        return enableAllAnchorPoints
          ? "Disable all anchor points"
          : "Enable all anchor points";
      case "deleteIcon":
        if (!disableEditDeleteIcon) {
          return "Click to delete";
        } else {
          return "Select a row to delete";
        }
      case "editIcon":
        if (!disableEditDeleteIcon) {
          return "Click to edit";
        } else {
          return "Select a row to edit";
        }
      case "addIcon":
        return disableAddIcon ? "Disabled" : "Click to add";
      default:
        return "";
    }
  };
  const allowAddAnchorPoint = featureFlags.isFeatureEnabled(
    appConstants.features.AllowAddAnchorPoint
  );
  const disableAddIcon = !allowAddAnchorPoint || isAddUpdateAnchorPointFormOpen;
  const disableEditDeleteIcon =
    !selectedAnchorPoints?.length ||
    isAddUpdateAnchorPointFormOpen 
  const params = {
    isAddUpdateAnchorPointFormOpen,
    disableEditDeleteIcon,
    enableAllAnchorPoints,
    disableAddIcon
  };
  return (
    <div className={classes.headerStyle}>
      <span
        className={classes.headerLabel}
        data-automationid="anchorPoint-title"
      >
        Anchor Points
      </span>
      <span
        className={`${classes.headerIconStyles} ${classes.iconLayout}  ${
          disableAddIcon
            ? classes.disableIcon
            : classes.enableIcon
        }`}
        onClick={allowAddAnchorPoint ? addAnchorPointOpen : null}
      >
        <Tooltip title={getIconTitle({ iconName: "addIcon", ...params })}>
          <AddRoundedIcon />
        </Tooltip>
      </span>
      <span
        className={`${classes.headerIconStyles} ${classes.iconLayout} ${
          disableEditDeleteIcon ? classes.disableIcon : classes.enableIcon
        }`}
        onClick={!disableEditDeleteIcon ? updateAnchorPointOpen : null}
      >
        <Tooltip title={getIconTitle({ iconName: "editIcon", ...params })}>
          <EditIcon />
        </Tooltip>
      </span>
      <span
        className={`${classes.headerIconStyles} ${classes.iconLayout} ${
          disableEditDeleteIcon ? classes.disableIcon : classes.enableIcon
        }`}
        onClick={!disableEditDeleteIcon ? deleteAnchorPointPopupOpen : null}
      >
        <Tooltip title={getIconTitle({ iconName: "deleteIcon", ...params })}>
          <DeleteOutlineIcon />
        </Tooltip>
      </span>
      <span
        className={`${classes.headerIconStyles} ${classes.toggleIconLayout} ${
          isAddUpdateAnchorPointFormOpen ? classes.disableIcon : ""
        }`}
      >
        <ToggleAnchorPoints
          isEnabled={enableAllAnchorPoints}
          isOnClickDisabled={isAddUpdateAnchorPointFormOpen}
          title={getIconTitle({
            iconName: "toggleAllAnchorPoint",
            ...params,
          })}
          isEnableAnchorPointsInProgress={isEnableAnchorPointsInProgress}
          onClick={
            isAddUpdateAnchorPointFormOpen
              ? null
              : () => onAllAnchorPointToggleClicked(!enableAllAnchorPoints)
          }
          className={
            isAddUpdateAnchorPointFormOpen
              ? classes.disableIcon
              : classes.enableIcon
          }
        />
      </span>
    </div>
  );
};
export default compose(
  withStyles(styles),
  withFeatureFlags
)(AnchorPointGridHeader);
